import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { filter } from 'rxjs';
import { tap } from 'rxjs/operators';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import type { IJobStore } from '@app/interface/job/job-store.interface';
import type { IShoppingCartStore } from '@app/interface/cart/shopping-cart-store.interface';
import { isFraudDetected, isUserProfileUrl } from '@app/interceptor';
import type { SubjectStore } from '@app/interface/subject/subject-store.interface';

@Injectable()
export class UserProfileInterceptor implements HttpInterceptor {
  private jobStore: IJobStore = inject(angularjs.JobStore);
  private shoppingCartStore: IShoppingCartStore = inject(angularjs.ShoppingCartStore);
  private subjectStore: SubjectStore = inject<SubjectStore>(angularjs.SubjectStore);

  constructor() {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      filter((event) => event instanceof HttpResponse),
      tap((event) => this.handleResponse(event))
    );
  }

  private handleResponse(response: HttpResponse<any>): void {
    if (!isUserProfileUrl(response.url ?? undefined)) {
      return;
    }

    const data = response.body?.data;
    if (isFraudDetected(data)) {
      this.jobStore.clearAll();
      this.jobStore.clearJobData();
      this.subjectStore.clearAll();
      this.shoppingCartStore.clearAll();
    }
  }
}
